import { isPlainObject } from 'lodash';
/**
 * 在 nextjs 中图片是一个对象
 */
export function getImageSrc(value) {
  return isPlainObject(value) ? value.src : value;
}